import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule } from '@angular/http';
import { Router } from '@angular/router';
import { routing } from './app.routing';

import { DatepickerModule  } from 'ng2-bootstrap';

import { AppComponent } from './app.component';
import { ContextMenuComponent } from './components/ContextMenu/contextMenu.component';
import { GridComponent } from './components/Grid/grid.component';
import { CustomerListComponent } from './components/Customer/customerList.component';
import { DateModalComponent } from './components/DateModal/dateModal.component';
import { ContextFilterComponent } from './components/Grid/filter.component';
import { TextEditorComponent } from './components/Grid/textEditor.component';
import { QtyEditorComponent } from './components/Grid/qtyEditor.component';
import { DateEditorComponent } from './components/Grid/dateEditor.component';
import { YesNoEditorComponent } from './components/Grid/yesno.component';
import { PaginationDirective } from './components/Grid/pagination.directive';
import { ModalComponent } from './components/Modal/modal.component';
import { NavbarModule } from './components/navbar/navbar.module';
import { CustomerService } from './services/customer.service';
import { LoginComponent } from './components/Login/login.component';
import { WebApiService } from './services/webapi.service';
import { HomeComponent } from './components/Home/home.component';
import { DockDirective } from './directives/dock.directive';
import { CustomerDetailComponent } from './components/Customer/customerDetail.component';
import { SystemService } from './services/system.service';
import { SystemComponent } from './components/System/system.component';
import { SizableDirective } from './directives/sizable.directive';
import { CustomerLedgerComponent } from './components/Customer/customerLedger.component';

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    ContextMenuComponent,
    ContextFilterComponent,
    SystemComponent,
    GridComponent,
    CustomerListComponent,
    CustomerDetailComponent,
    CustomerLedgerComponent,
    ModalComponent,
    DateModalComponent,
    TextEditorComponent,
    QtyEditorComponent,
    DateEditorComponent,
    YesNoEditorComponent,
    PaginationDirective,
    SizableDirective,
    DockDirective
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    NavbarModule,
    routing,
    DatepickerModule.forRoot()
  ],
  providers: [
    CustomerService,
    SystemService,
    WebApiService
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts